import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import {CardComponent} from '../../../../shared/components/card/card.component';
import {MatSlideToggle} from '@angular/material/slide-toggle';
import {IconComponent} from '../../../../shared/icons/icon.component';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {Router, RouterLink, RouterLinkActive} from '@angular/router';
import {RouteConstants} from '../../../../shared/constants/route-constants';
import {MatDialog} from '@angular/material/dialog';
import {ConfirmDialogComponent, ConfirmDialogData} from '../../../../shared/components/confirm-dialog/confirm-dialog.component';
import {filter, take} from 'rxjs';
import {ContextMenuComponent, ContextMenuData} from '../../../../shared/components/context-menu/context-menu.component';
import {FormsModule} from '@angular/forms';
import {RuleViewModel} from '../../models/rule-view-model.interface';
import {IconsPipe} from '../../../../shared/pipes/icons.pipe';
import {LabelConverter} from '../../../../shared/converter/label.converter';
import {TextWithIconComponent} from '../../../../shared/components/text-with-icon/text-with-icon.component';
import {RuleNamePipe} from '../../pipes/rule-name.pipe';

@Component({
  selector: 'app-rule-item-card',
  imports: [
    IconComponent,
    CardComponent,
    MatSlideToggle,
    TranslatePipe,
    RouterLink,
    RouterLinkActive,
    ContextMenuComponent,
    FormsModule,
    IconsPipe,
    TextWithIconComponent,
    RuleNamePipe,
  ],
  templateUrl: './rule-item-card.component.html',
  styleUrl: './rule-item-card.component.scss'
})
export class RuleItemCardComponent {
  private dialog = inject(MatDialog);
  private router = inject(Router);
  private translateService = inject(TranslateService);


  @Input() rule!: RuleViewModel;
  @Input() disabled: boolean = false;
  @Output() delete = new EventEmitter<string>()
  @Output() changeIsActive = new EventEmitter<{ id: string, isActive: boolean }>()

  limit = 3

  get description(): string | null {
    return this.rule.actions?.map(a => a.device?.name || a.deviceGroup?.name).join(',') ?? null;
  }

  get conditions(): any[] {
    return [
      ...this.rule.conditions,
      ...this.rule.orConditions
    ];
  }

  contextMenu: ContextMenuData[] = [
    {
      labelKey: "default.edit",
      action: () => this.router.navigate([RouteConstants.routeRule, RouteConstants.routeUpdate, this.rule.id])
    },
    // {
    //   labelKey: "default.duplicate",
    //   action: () => this.router.navigate([RouteConstants.routeRule, RouteConstants.routeUpdate]) // todo
    // },
    {
      labelKey: "default.delete",
      action: () => this.onDelete()
    }
  ];

  onDelete(): void {
    const dialogData: ConfirmDialogData = {
      title: this.translateService.instant('rules.delete.title'),
      body: this.translateService.instant('rules.delete.body'),
      hint: this.translateService.instant('rules.delete.hint'),
      confirmLabel: this.translateService.instant('default.delete'),
    }

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: dialogData,
    });

    dialogRef.afterClosed()
      .pipe(
        take(1),
        filter((result): result is true => result === true)
      )
      .subscribe(_ => {
        this.delete.emit(this.rule.id)
      });
  }

  onChangeIsActive(value: boolean) {
    this.changeIsActive.emit({id: this.rule.id, isActive: value})
  }

  protected readonly RouteConstants = RouteConstants;
  protected readonly LabelConverter = LabelConverter;
}
